// export const SERVER_URL = "http://localhost:5000"
export const SERVER_URL = "https://defilaunch.app"